export const TIME_INTERVALS = Object.freeze({
  infinity: Infinity,
  eightHours: 1000 * 60 * 60 * 8,
  oneHour: 1000 * 60 * 60,
  fiveMinutes: 1000 * 60 * 5,
  oneMinute: 1000 * 60,
});
